import * as Joi from 'joi';
import { CardType, Currency } from '../enums/retrieve-transaction.enums';

export const UpdateMIDsSchema = Joi.object({
  midName: Joi.string().trim().max(50).required().messages({
    'any.required': 'MID name is required.',
    'string.base': 'Invalid MID name.',
    'string.empty': 'Invalid MID name.',
    'string.max': 'Merchant MID name must have at most 50 characters only.',
  }),
  switchId: Joi.number().integer().required().messages({
    'any.required': 'Switch is required.',
    'number.base': 'Invalid switch.',
    'number.integer': 'Invalid switch.',
  }),
  cardTypeId: Joi.number()
    .valid(...Object.values(CardType))
    .required()
    .messages({
      'any.only': 'Invalid card type selected.',
      'any.required': 'Card type is required.',
      'number.base': 'Invalid card type.',
    }),
  currencyId: Joi.number()
    .valid(Currency.PHP, Currency.USD)
    .required()
    .messages({
      'any.only': 'Invalid currency selected.',
      'any.required': 'Currency is required.',
      'number.base': 'Invalid currency.',
    }),
  isActive: Joi.boolean().required().messages({
    'any.only': 'Invalid association active status.',
    'any.required': 'Association active status is required.',
    'boolean.base': 'Invalid association active status.',
  }),

  xpayMarkup: Joi.number().max(9999999).required().messages({
    'any.required': 'Xpay mark up is required.',
    'number.base': 'Xpay mark up is invalid.',
    'number.max': 'Xpay mark up is invalid.',
  }),
  acquirerBuyRate: Joi.number().max(9999999).required().messages({
    'any.required': 'Acquirer Buy Rate is required.',
    'number.base': 'Acquirer Buy Rate is invalid.',
    'number.max': 'Acquirer Buy Rate is invalid.',
  }),
  declineRate: Joi.number().max(9999999).required().messages({
    'any.required': 'Decline is required.',
    'number.base': 'Decline is invalid.',
    'number.max': 'Decline is invalid.',
  }),
  xpayPerTransactionAddOn: Joi.number().max(9999999).required().messages({
    'any.required': 'Per Transaction Add-on (Xpay) is required.',
    'number.base': 'Per Transaction Add-on is (Xpay) invalid.',
    'number.max': 'Per Transaction Add-on is (Xpay) invalid.',
  }),
  xpayPerTransactionAddOn: Joi.number().max(9999999).required().messages({
    'any.required': 'Per Transaction Add-on (Xpay) is required.',
    'number.base': 'Per Transaction Add-on is (Xpay) invalid.',
    'number.max': 'Per Transaction Add-on is (Xpay) invalid.',
  }),
  clientPerTransactionAddOn: Joi.number().max(9999999).required().messages({
    'any.required': 'Per Transaction Add-on (Client) is required.',
    'number.base': 'Per Transaction Add-on is (Client) invalid.',
    'number.max': 'Per Transaction Add-on is (Client) invalid.',
  }),
  fraudControlFee: Joi.number().max(9999999).required().messages({
    'any.required': 'Fraud control fee is required.',
    'number.base': 'Fraud control fee is invalid.',
    'number.max': 'Fraud control fee is invalid.',
  }),
  preAuthRate: Joi.number().max(9999999).required().messages({
    'any.required': 'Pre auth rate is required.',
    'number.base': 'Pre auth rate is invalid.',
    'number.max': 'Pre auth rate is invalid.',
  }),
  captureRate: Joi.number().max(9999999).required().messages({
    'any.required': 'Capture rate is required.',
    'number.base': 'Capture rate is invalid.',
    'number.max': 'Capture rate is invalid.',
  }),
  clientMarkup: Joi.number().max(9999999).required().messages({
    'any.required': 'Client mark up is required.',
    'number.base': 'Client mark up is invalid.',
    'number.max': 'Client mark up is invalid.',
  }),
  refundRate: Joi.number().max(9999999).required().messages({
    'any.required': 'Refund rate is required.',
    'number.base': 'Refund rate is invalid.',
    'number.max': 'Refund rate is invalid.',
  }),
  voidRate: Joi.number().max(9999999).required().messages({
    'any.required': 'Void rate is required.',
    'number.base': 'Void rate is invalid.',
    'number.max': 'Void rate is invalid.',
  }),
  cashBackRate: Joi.number().max(9999999).required().messages({
    'any.required': 'Cash back rate is required.',
    'number.base': 'Cash back rate is invalid.',
    'number.max': 'Cash back rate is invalid.',
  }),
  balanceInquiryRate: Joi.number().max(9999999).required().messages({
    'any.required': 'Balance inquiry rate is required.',
    'number.base': 'Balance inquiry rate is invalid.',
    'number.max': 'Balance inquiry rate is invalid.',
  }),

  param3: Joi.string().trim().max(50).optional().allow('').messages({
    'string.base': 'Invalid secure hash.',
    'string.empty': 'Invalid secure hash.',
    'string.max': 'Secure hash must have at most 50 characters only.',
  }),
  param2: Joi.number().integer().optional().messages({
    'number.base': 'Merchant ID is invalid.',
    'number.integer': 'Merchant ID is invalid.',
  }),
  param6: Joi.string().trim().max(50).optional().allow('').messages({
    'string.base': 'Invalid terminal ID.',
    'string.empty': 'Invalid terminal ID.',
    'string.max': 'Terminal ID must have at most 50 characters only.',
  }),
  mcc: Joi.string().trim().required().messages({
    'any.required': 'MCC is required.',
    'string.base': 'MCC is invalid.',
    'string.empty': 'MCC is invalid.',
  }),
  pemFile: Joi.any(),
});
